import React, { ReactElement, useCallback } from 'react';
import { SelectablePeriodTemplateState } from 'adapter/in/common/components/PeriodSelector';
import { useBranding } from 'adapter/in/common/context/static/Branding';
import { useProfile } from 'adapter/in/common/context/static/Profile';
import { FormPeriodSelector, onChangePeriodSelector } from 'adapter/in/common/form/PeriodSelector';
import { SelectorContainerProps } from 'adapter/in/common/form/Selector';
import { FieldStatus, SelectorType } from 'adapter/in/common/form/types';
import { useBaseDashboardsApiSelector } from 'adapter/in/common/hooks/form/useBaseDashboardsApiSelector';
import { useBaseSelectorContainer } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import { dispatchFormChangesView } from 'adapter/in/common/context/formChanges';

export const ApiPeriodSelectorContainer = ({
    name,
    affectsTo,
    dataDependsOn,
    pageSize,
    label,
    configType,
    disabled,
}: SelectorContainerProps): ReactElement => {
    const { branding } = useBranding();
    const { profile } = useProfile();
    const { value, onChange, shouldLoad, dependantValues } = useBaseSelectorContainer(
        name,
        {
            validate: (v) => [FieldStatus.DEFAULT_DATA, FieldStatus.HAS_VALUE].includes(v.status),
        },
        undefined,
        dataDependsOn,
        affectsTo
    );
    const { setHasChange: setWidgetMenuHasChange } = dispatchFormChangesView();
    const callbackOnChange = useCallback(
        (updatedValue) => {
            onChange(updatedValue);
        },
        [onChange]
    );

    const { options } = useBaseDashboardsApiSelector<SelectablePeriodTemplateState>(
        name,
        SelectorType.PERIOD,
        configType,
        pageSize ?? 0,
        value,
        shouldLoad,
        dependantValues,
        callbackOnChange
    );

    return (
        <FormPeriodSelector
            label={label}
            primaryColor={branding.primaryColor}
            onChange={(data) => {
                setWidgetMenuHasChange(true);
                onChangePeriodSelector(callbackOnChange, configType)(data);
            }}
            disabled={disabled}
            value={value}
            options={options}
            dateFormat={profile.dateFormat}
        />
    );
};
